module.exports = __webpack_public_path__ + "img/12.2c6511fb.png";